import { useEffect } from 'react'
import { useQuery } from 'react-query'

import { API_SESSIONS_PLUGIN, getSessionsPlugin } from '../../api/endpoints/sessions'
import styled from 'styled-components/macro'
import { useHomeContext } from '../HomeContext'

type Params = {
    hostId: number
}

export const SessionsPlugin = ({ hostId }: Params) => {
    const { momenceLeadId } = useHomeContext()
    const { isFetched: isPluginFetched } = useQuery([hostId, API_SESSIONS_PLUGIN], () => getSessionsPlugin(hostId))

    useEffect(() => {
        if (hostId && isPluginFetched) {
            const script = document.createElement('script')

            script.src = 'https://momence.com/plugin/host-schedule/host-schedule.js'
            script.async = true
            script.setAttribute('host_id', hostId.toString())
            script.setAttribute('default_filter', 'show-all')

            if (momenceLeadId) {
                script.setAttribute('momenceLeadId', momenceLeadId)
            }

            document.body.appendChild(script)

            return () => {
                document.body.removeChild(script)
            }
        }
    }, [hostId, isPluginFetched, momenceLeadId])

    return (
        <Wrapper>
            <div id="momence-plugin-host-schedule" />
        </Wrapper>
    )
}

const Wrapper = styled.div`
    min-height: 3rem;

    @media (max-width: 430px) {
        margin: 0 -16px;
        margin-top: -2rem;
    }

    margin: 0 -32px;
    margin-top: -2rem;
`
